/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 11:29:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 20:35:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/slice/index.ts
 */
import { createSelector, createSlice } from '@reduxjs/toolkit';
import arrayMove from 'array-move';
import _ from 'lodash';
import {
  convertOptionToRedux,
  generateNewOption,
  generateNewServiceInMap,
} from 'src/pages/ProductEditor/VirtualProduct/common';
import { validation as _validation } from 'src/pages/ProductEditor/VirtualProduct/tools';
import {
  getAdvancedPriceSettings as _getAdvancedPriceSettings,
  getBrands as _getBrands,
  getCollapse as _getCollapse,
  getCurrencies as _getCurrencies,
  getHasModified as _getHasModified,
  getInventoryUuid as _getInventoryUuid,
  getLastModified as _getLastModified,
  getLinkedSalesChannels as _getLinkedSalesChannels,
  getLoaded as _getLoaded,
  getPriceSettings as _getPriceSettings,
  getProductInfo as _getProductInfo,
  getProductIsSold as _getProductIsSold,
  getProductName as _getProductName,
  getProductType as _getProductType,
  getState as _getState,
  getStatus as _getStatus,
  getStock as _getStock,
  getTags as _getTags,
  getThumbnailImage as _getThumbnailImage,
  getUuid as _getUuid,
  onAdvancedPriceAdd as _onAdvancedPriceAdd,
  onAdvancedPriceChange as _onAdvancedPriceChange,
  onBrandsAdd as _onBrandsAdd,
  //getSalesChannelAvailableQuantity as _getSalesChannelAvailableQuantity,
  onLinkedSalesChannelsProductsChange as _onLinkedSalesChannelsProductsChange,
  onLinkedSalesChannelsProductsDelete as _onLinkedSalesChannelsProductsDelete,
  onPriceChange as _onPriceChange,
  //onSalesChannelAvailableChange as _onSalesChannelAvailableChange,
  onStockChange as _onStockChange,
  onTagsChange as _onTagsChange,
  onThumbnailImageChange as _onThumbnailImageChange,
  reducerTarget,
  willUnmount,
} from 'src/pages/ProductEditor/slice/common';
import { EnumReducers } from 'src/pages/ProductEditor/slice/constants';
import {
  generateActivateProductThunk,
  generateArchiveProductThunk,
  generateDraftProductThunk,
  generateDuplicateThunk,
  generateFetchThunk,
  generateSubmitThunk,
} from 'src/pages/ProductEditor/tools/commonRequests';
import { assData, clearError } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { ActionType } from 'src/types/common/common';
import { EnumCollapseId, defaultData } from '../common';
export { EnumCollapseId };
export { ActionType };
//import { onFinishFailed } from 'src/tools/helper';

//import { generateErrorKey } from 'src/tools/helper';
//import { validation as _validation } from '../tools';
//import { msg } from 'src/tools/message';
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  convertDataFromServerToRedux,
  convertProductFromServerToRedux,
} from '../tools';

const activeProduct = generateActivateProductThunk(
  'storeProductVirtualActivateProduct',
);
const draftProduct = generateDraftProductThunk(
  'storeProductVirtualDraftProduct',
);
const archiveProduct = generateArchiveProductThunk(
  'storeProductVirtualArchiveProduct',
);

const submitProduct = generateSubmitThunk('storeProductSubmitProduct');
const fetchProduct = generateFetchThunk('storeProductFetchProduct');
const duplicateProduct = generateDuplicateThunk('storeProductDuplicateProduct');

// export const fetchLegalPage = createAsyncThunk(
//   'fetchSalesChannelLegalPageDetail',
//   async (
//     data: { uuid: string },
//     //thunkAPI,
//   ) => {
//     const { uuid } = data;
//     const response = await getLegalPage(uuid);
//     return { response };
//   },
// );

// export const submitLegalPage = createAsyncThunk(
//   'submitSalesChannelLegalPageDetail',
//   async (obj: any) =>
//     //thunkAPI,
//     {
//       const { data } = obj;
//       const response = await postLegalPage(data);
//       return { response };
//     },
// );

const legalEditorReducers = (state, reducer) => {
  const reducers = [EnumReducers.virtualProduct, reducer];
  const _r = reducerTarget(state, reducers);
  return _r;
};

const defaultState = {
  ...defaultData,
};

const storeProductVirtual = createSlice({
  name: 'storeProductVirtual',
  initialState: defaultState,
  reducers: {
    initializeData(state) {
      state.loaded = true;
    },
    updateEssentialData(state) {
      state.loaded = true;
    },
    resetData(state) {
      willUnmount({ state, defaultState });
    },
    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },
    onBrandsAdd(state, action) {
      _onBrandsAdd(state, action);
    },
    onExpirationDateSetting(state, action) {
      state.hasModified = true;
      state.productGiftCardSetting = {
        redemptionCode: (state.productGiftCardSetting || {}).redemptionCode,
        expirationDateSetting: {
          ...((state.productGiftCardSetting || {}).expirationDateSetting || {}),
          ...(action.payload || {}),
          ...clearError(action.payload),
        },
      };
    },
    onRedemptionCodeSetting(state, action) {
      state.hasModified = true;
      state.productGiftCardSetting = {
        redemptionCode: action.payload,
        expirationDateSetting: (state.productGiftCardSetting || {})
          .expirationDateSetting,
        ...clearError(action.payload),
      };
    },
    onCodesDelete(state, action) {
      state.hasModified = true;
      const { index } = action.payload;
      state.productInfo.codes.splice(index, 1);
    },
    onCodesChange(state, action) {
      state.hasModified = true;
      const { index, code } = action.payload;
      state.productInfo.codes[index] = {
        ...state.productInfo.codes[index],
        ...clearError({ code }),
      };
    },
    onProductTypeChange(state, action) {
      state.hasModified = true;
      state.productType = action.payload;
    },
    onProductInfoChange(state, action) {
      state.hasModified = true;
      state.productInfo = {
        ...state.productInfo,
        ...clearError(action.payload),
      };
    },
    onTagsChange(state, action) {
      _onTagsChange(state, action);
    },
    onImageChange(state, action) {
      _onThumbnailImageChange(state, action);
    },
    onAdvancedPriceChange(state, action) {
      _onAdvancedPriceChange(state, action);
    },
    onPriceChange(state, action) {
      _onPriceChange(state, action);
    },
    onAdvancedPriceAdd(state) {
      _onAdvancedPriceAdd(state);
    },
    // onSalesChannelAvailableChange(state, action) {
    //   _onSalesChannelAvailableChange(state, action);
    // },
    onStockChange(state, action) {
      _onStockChange(state, action);
    },
    onLinkedSalesChannelsProductsChange(state, action) {
      _onLinkedSalesChannelsProductsChange(state, action);
    },
    onProductDenominationsCurrencyChange(state, action) {
      state.hasModified = true;
      state.productDenominations.currency = action.payload;
      state.salesChannelUsageUuids = [];
    },
    onSalesChannelUsageUuidsChange(state, action) {
      state.hasModified = true;
      state.salesChannelUsageUuids = action.payload;
    },
    onProductDenominationsDenominationsChange(state, action) {
      state.hasModified = true;
      const { index, type, value } = action.payload;
      if (type === ActionType.delete) {
        state.productDenominations.denominations.splice(index, 1);
      }
      if (type === ActionType.add) {
        state.productDenominations.denominations.push(0);
      }
      if (type === ActionType.modify) {
        state.productDenominations.denominations[index] = value;
      }
      //state.productDenominations.denominations = action.payload;
    },
    onProductDetailChange(state, action) {
      state.hasModified = true;

      const { detailUuid, value, type } = action.payload;
      if (type === ActionType.delete) {
        delete state.serviceDetails[detailUuid];
        _.remove(state.serviceDetailsOrder, (i) => i === detailUuid);
      }
      if (type === ActionType.add) {
        const currentAmount = (state.serviceDetailsOrder || []).length;
        const data = generateNewServiceInMap({ index: currentAmount + 1 });
        //
        const { data: _data, order } = data;
        const [uuid] = order;
        state.serviceDetails[uuid] = _data[uuid];
        state.serviceDetailsOrder.push(uuid);
      }
      if (type === ActionType.modify) {
        state.serviceDetails[detailUuid] = {
          ...state.serviceDetails[detailUuid],
          ...clearError(value),
        };
      }
    },
    onProductDetailOptionsChange(state, action) {
      state.hasModified = true;
      const { detailUuid, value, type, index, from, to } = action.payload;
      const _target = state.serviceDetails[detailUuid];
      if (type === ActionType.delete) {
        _target.options.splice(index, 1);
      }
      if (type === ActionType.add) {
        const count = _target.options.length + 1;

        _target.options.push(convertOptionToRedux(generateNewOption(count)));
      }
      if (type === ActionType.modify) {
        _target.options[index].value = value;
      }
      if (type === ActionType.reorder) {
        _target.options = arrayMove(_target.options, from, to);
      }
    },

    validation(state, action) {
      _validation({ state, furtherStatus: action.payload });
    },
    onLinkedSalesChannelsProductsDelete(state, action) {
      _onLinkedSalesChannelsProductsDelete(state, action);
    },
    onProductLoad(state, action) {
      const response: any = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};
      assData(state, _data);
    },
    onHasModified(state) {
      state.hasModified = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProduct.fulfilled, (state, action) => {
      const response: any = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};

      assData(state, _data);
    });
    builder.addCase(duplicateProduct.fulfilled, (state, action) => {
      const d: any = action.payload;

      const { response, extra } = d;
      const { productStatus, title } = extra;
      //console.log('productStatus', productStatus);
      response.uuid = null;
      response.name = title;
      response.status = productStatus;
      response.sku = null;

      const _data: any =
        convertProductFromServerToRedux(response, state.priceTiers) || {};

      assData(state, _data);
      state.linkedSalesChannels = [];
      state.hasModified = true;
    });
    builder.addCase(activeProduct.fulfilled, (state, action) => {
      const response: any = action.payload;
      const _data =
        convertProductFromServerToRedux(response, state.priceTiers) || {};

      assData(state, _data);
    });
    builder.addCase(draftProduct.fulfilled, (state, action) => {
      const response: any = action.payload;
      const _data =
        convertProductFromServerToRedux(response, state.priceTiers) || {};
      assData(state, _data);
    });
    builder.addCase(archiveProduct.fulfilled, (state, action) => {
      const response: any = action.payload;
      const _data =
        convertProductFromServerToRedux(response, state.priceTiers) || {};
      assData(state, _data);
    });
    builder.addCase(submitProduct.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitProduct.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitProduct.fulfilled, (state, action) => {
      const { response, hideMsg } = action.payload;
      const _data: any =
        convertProductFromServerToRedux(response, state.priceTiers) || {};
      if (!hideMsg)
        msg.success(
          getI18nFromGeneral('general.status.changessavesuccessfully'),
        );
      assData(state, _data);
    });
  },
});
export const {
  onStockChange,
  //onSalesChannelAvailableChange,
  resetData,
  onCollapseChange,
  validation,
  onProductInfoChange,
  onBrandsAdd,
  onCodesDelete,
  onCodesChange,
  onProductTypeChange,
  onTagsChange,
  onImageChange,
  onAdvancedPriceChange,
  onPriceChange,
  onAdvancedPriceAdd,
  onLinkedSalesChannelsProductsChange,
  onProductDenominationsCurrencyChange,
  onProductDenominationsDenominationsChange,
  onProductDetailChange,
  updateEssentialData,
  onProductDetailOptionsChange,
  onLinkedSalesChannelsProductsDelete,
  onRedemptionCodeSetting,
  onExpirationDateSetting,
  onSalesChannelUsageUuidsChange,
  onProductLoad,
  onHasModified,
} = storeProductVirtual.actions;

const getPageName = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'productInfo').name,
    (name) => {
      return name;
    },
  );
};

const getDenomination = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'productDenominations'),
    (name) => {
      return name;
    },
  );
};

const getProductDetailOrder = () => {
  return createSelector(
    // (state: any) => legalEditorReducers(state, 'serviceDetails'),
    (state: any) => legalEditorReducers(state, 'serviceDetailsOrder'),
    (serviceDetailsOrder) => {
      return serviceDetailsOrder;
    },
  );
};

const getProductDetailData = (id) => {
  return createSelector(
    // (state: any) => legalEditorReducers(state, 'serviceDetails'),
    (state: any) => legalEditorReducers(state, 'serviceDetails')[id],
    (serviceDetails) => {
      return serviceDetails;
    },
  );
};

const getSalesChannels = () => {
  return createSelector(
    // (state: any) => legalEditorReducers(state, 'serviceDetails'),
    (state: any) => legalEditorReducers(state, 'allSalesChannels'),
    (allSalesChannels) => {
      return allSalesChannels;
    },
  );
};

const getSalesChannelUsage = () => {
  return createSelector(
    // (state: any) => legalEditorReducers(state, 'serviceDetails'),
    (state: any) => legalEditorReducers(state, 'salesChannelUsageUuids'),
    (allSalesChannels) => {
      return allSalesChannels;
    },
  );
};

const getCollapse = (id) => {
  return _getCollapse(EnumReducers.virtualProduct, id);
};

const getState = () => {
  return _getState(EnumReducers.virtualProduct);
};

const getHasModified = () => {
  return _getHasModified(EnumReducers.virtualProduct);
};

const getUuid = () => {
  return _getUuid(EnumReducers.virtualProduct);
};

const getLoaded = () => {
  return _getLoaded(EnumReducers.virtualProduct);
};

const getLastModified = () => {
  return _getLastModified(EnumReducers.virtualProduct);
};

const getProductName = () => {
  return _getProductName(EnumReducers.virtualProduct);
};

const getStatus = () => {
  return _getStatus(EnumReducers.virtualProduct);
};

const getProductInfo = () => {
  return _getProductInfo(EnumReducers.virtualProduct);
};

const getBrands = () => {
  return _getBrands(EnumReducers.virtualProduct);
};

const getProductType = () => {
  return _getProductType(EnumReducers.virtualProduct);
};

const getProductIsSold = () => {
  return _getProductIsSold(EnumReducers.virtualProduct);
};

const getTags = () => {
  return _getTags(EnumReducers.virtualProduct);
};

const getThumbnailImage = () => {
  return _getThumbnailImage(EnumReducers.virtualProduct);
};

const getAdvancedPriceSettings = () => {
  return _getAdvancedPriceSettings(EnumReducers.virtualProduct);
};

const getPriceSettings = () => {
  return _getPriceSettings(EnumReducers.virtualProduct);
};

const getCurrencies = () => {
  return _getCurrencies(EnumReducers.virtualProduct);
};

const getStock = () => {
  return _getStock(EnumReducers.virtualProduct);
};

// const getSalesChannelAvailableQuantity = () => {
//   return _getSalesChannelAvailableQuantity(EnumReducers.virtualProduct);
// };

const getInventoryUuid = () => {
  return _getInventoryUuid(EnumReducers.virtualProduct);
};

const getLinkedSalesChannels = () => {
  return _getLinkedSalesChannels(EnumReducers.virtualProduct);
};

export {
  activeProduct,
  archiveProduct,
  draftProduct,
  duplicateProduct,
  fetchProduct,
  getAdvancedPriceSettings,
  getBrands,
  getCollapse,
  getCurrencies,
  getDenomination,
  getHasModified,
  getInventoryUuid,
  getLastModified,
  getLinkedSalesChannels,
  getLoaded,
  getPageName,
  getPriceSettings,
  getProductDetailData,
  getProductDetailOrder,
  getProductInfo,
  getProductIsSold,
  getProductName,
  getProductType,
  getSalesChannelUsage,
  getSalesChannels,
  getState,
  //getSalesChannelAvailableQuantity,
  getStatus,
  getStock,
  getTags,
  getThumbnailImage,
  getUuid,
  submitProduct,
};

export default storeProductVirtual.reducer;
